import { css, CSSResult } from 'lit'
import { csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseLabel = {
  color: css`var(--cse-label-color, ${csColorText.body})`,
  gap: css`var(--cse-label-gap, ${csSpacing.spacing04})`,
  optionalColor: css`var(--cse-label-optional-color, ${csColorText.muted})`,
  requiredColor: css`var(--cse-label-required-color, ${csColorFunctional.error})`,
  fontWeight: css`var(--cse-label-font-weight, 700)`,
  titleIconColor: css`var(--cse-label-title-icon-color, ${csColorFunctional.info})`,
}

export const style: CSSResult = css`
  .cse-label {
    --cse-text-color: ${cseLabel.color};
    align-items: baseline;
    column-gap: ${cseLabel.gap};
    display: inline-flex;
    font-weight: ${cseLabel.fontWeight}
  }

  .required {
    color: ${cseLabel.requiredColor};
  }

  .suffix {
    color: ${cseLabel.optionalColor};
  }

  cse-tooltip {
    display: flex;
  }

  .title-icon {
    color: ${cseLabel.titleIconColor};
  }
`
